"use client";

import React, { useRef, useEffect } from "react";
import useDimensions from "@/components/utilities/useDimensions";
import ImpersonationBanner from "./ImpersonationBanner";

const isBrowser = typeof window !== "undefined";

function AppBanners() {
	const bannerRef = useRef<HTMLDivElement>(null);
	const { height } = useDimensions(bannerRef);

	useEffect(() => {
		if (isBrowser) {
			document.body.style.setProperty("--banner-height", `${height}px`);
		}
	}, [height]);
	return (
		<div ref={bannerRef} className="z-header sticky top-0">
			<ImpersonationBanner />
		</div>
	);
}

export default AppBanners;
